import { ModuleHeader } from '../module-header'
import AvailableExamsItem from './available-exams-item'
import { AvailableExamsGrid } from './available-exams.style'

const AvailableExams = () => {
    return (
        <>
            <ModuleHeader title="AVAILABLE Exams" />
            <AvailableExamsGrid>
                <AvailableExamsItem />
                <AvailableExamsItem />
                <AvailableExamsItem />
                <AvailableExamsItem />
            </AvailableExamsGrid>
        </>
    )
}

export { AvailableExams }
